import { logRecevied } from "./loger"

export function setInContextHelper(msg, setContext) {
    logRecevied(msg)
    Object.keys(msg.data).length && setContext((ctx) => {
        return { ...ctx, [msg.service]: msg.data }
    })
}

export function addInHistory(msg, setContext) {
    const length = 50
    setContext((ctx) => {
        const player_id = ctx.auth.player_id
        const newBetData = [
            {
                ...msg,
                round_id: msg.id,
                betAmount: +msg.bet_info?.bet,
                winCoef: +msg.bet_info?.coeff,
                winAmount: +msg.bet_info?.win
            }, ...ctx.history.all
        ]
        const newData = [
            ...ctx.history.all,
            {
                ...msg,
                round_id: msg.id,
                betAmount: +msg.bet_info?.bet,
                winCoef: +msg.bet_info?.coeff,
                winAmount: +msg.bet_info?.win
            }]

        const all = ctx.bet.bet_id ? newBetData : newData

        all.map((el) =>
            el.user_id === player_id
                ? { ...el, user_name: ctx.auth.player_name }
                : el
        ).slice(0, length)

        const my = all.filter((h) => h.user_id === player_id).map((el) => ({ ...el, user_name: ctx.auth.player_name })).slice(0, 18)

        const high = all.filter((h) => h.bet_info?.type === 'bigwin').map((el) =>
            el.user_id === player_id
                ? { ...el, user_name: ctx.auth.player_name }
                : el
        ).slice(0, length)
        return {
            ...ctx, 'history': {
                all,
                my,
                high,
            }
        }
    })
}